var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultSelect',{attrs:{"placeholder":'請選擇年度及學期',"items":_vm.ymsList,"itemText":'label',"itemValue":'value',"clearable":true,"errorsMsg":_vm.errorsMsg,"labeltxt":"請選擇年度及學期"},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"selectValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }